import { actionTypes } from '@core/js/hooks/useLiveGamesIntegration/store/constants';
import { ILiveGamesSubscription } from '@theme/js/hooks/useLiveGamesIntegration/types';

import {
    startLiveIntegration,
    updateIsNeedToStart,
    resetTables,
    setSocket,
    updateConnectionStatus,
    updateReconnectionStatus,
    removeSubscription,
    updateTables,
    addTables,
    removeTables,
    updateLiveGamesImagesTimestamp,
    updateLiveGamesImagesIntervalId,
    updateContextStatus
} from '@core/js/hooks/useLiveGamesIntegration/store/actions';

export {
    startLiveIntegration,
    updateIsNeedToStart,
    resetTables,
    setSocket,
    updateConnectionStatus,
    updateReconnectionStatus,
    removeSubscription,
    updateTables,
    addTables,
    removeTables,
    updateLiveGamesImagesTimestamp,
    updateLiveGamesImagesIntervalId,
    updateContextStatus
};

export const addSubscription =
    ({ tables, subscriptionId, correlationId, removedTables }: ILiveGamesSubscription) => ({
    type: actionTypes.LIVE_GAMES_SUBSCRIPTION_ADD,
    payload: { tables, subscriptionId, correlationId, removedTables }
});
